import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11a5eb92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "delivery-address" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content__name" }
const _hoisted_4 = { class: "content__description" }
const _hoisted_5 = { class: "content__address" }
const _hoisted_6 = {
  key: 0,
  class: "content__error"
}
const _hoisted_7 = {
  key: 1,
  class: "content__price"
}
const _hoisted_8 = { class: "rouble-symbol" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "rouble-symbol"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeliveryAddressForm = _resolveComponent("DeliveryAddressForm")!
  const _component_ItemPanel = _resolveComponent("ItemPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ItemPanel, {
      "is-default": _ctx.isSelected,
      "is-opened": _ctx.isFormOpened,
      onSetDefault: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('select'))),
      onOpenForm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleForm(true))),
      onSaveForm: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$refs.form.save()))
    }, {
      preview: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.deliveryAddress.name || `Адрес №${_ctx.addressNumber}`), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.deliveryAddress.fullName), 1),
            (_ctx.withZones && !_ctx.deliveryAddress.isDeliveryAvailable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, " По указанному адресу доставка не производится. "))
              : _createCommentVNode("", true),
            (_ctx.withZones && _ctx.deliveryAddress.deliveryZone?.minOrderPrice)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, [
                    _createTextVNode(" Минимальная сумма заказа для " + _toDisplayString(_ctx.deliveryAddress.deliveryZone.deliveryPrice ? '' : 'бесплатной') + " доставки ", 1),
                    _hoisted_9,
                    _createTextVNode(" " + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.deliveryAddress.deliveryZone.minOrderPrice)), 1)
                  ]),
                  (_ctx.deliveryAddress.deliveryZone.deliveryPrice)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, " . Стоимость доставки " + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.deliveryAddress.deliveryZone.deliveryPrice)), 1))
                    : _createCommentVNode("", true),
                  _createTextVNode(". ")
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      form: _withCtx(() => [
        _createVNode(_component_DeliveryAddressForm, {
          ref: "form",
          "delivery-address": _ctx.deliveryAddress,
          onClose: _ctx.toggleForm,
          onWasRemoved: _cache[0] || (_cache[0] = (id) => _ctx.$emit('wasRemoved', id)),
          onWasUpdated: _cache[1] || (_cache[1] = (address) => _ctx.$emit('wasUpdated', address))
        }, null, 8, ["delivery-address", "onClose"])
      ]),
      _: 1
    }, 8, ["is-default", "is-opened"])
  ]))
}